import React, { useEffect, useRef } from 'react';
import { Field, reduxForm, InjectedFormProps, getFormValues, reset } from 'redux-form';
import { connect } from 'react-redux';
import FileUpload from '../../../commonfields/FileUpload';
import { fileFormats } from '../../../utils/GeneralUtils';


interface MyFormProps {
   uploadFiles:Function;
}


interface FormData {
  exampleField: string;
}


const UploadFile: React.FC<any& InjectedFormProps<Record<string, MyFormProps>, any>> = (props) => {

  const childref = useRef<any>(); 
  
    useEffect(()=>{       
        props.uploadFiles(props.formValues);
       props.formValues?.documentTemplate&& props?.change("documentTemplate",null); 
       //Handling Duplication issue       
      childref?.current && childref.current();
           
    },[props.formValues])

 

  return (   

    <form> 
        <div className="documentTabsFileUpload">     
    <Field
      component={FileUpload}
      acceptedFormats={fileFormats}
      displayAccepedFormats={false}    
      noClick={false}
      noDrag={false}
      name="documentTemplate"
      label={""}
      browse={"Upload"}
      maxSize={20 * 1024 * 1024}
      disabled={false}
      showFilesList={true}
      optional={true}
      reference={childref} 
    />
     </div>
   </form> 
  
  );
};

const mapStateToProps = (state: any, props: any) => {
    return {
      initialValues: props.initialData,
      formValues: getFormValues("DocumentsTabForm")(state),
    };
  };

const ConnectedForm = reduxForm<FormData, MyFormProps>({
  form: 'DocumentsTabForm', 
})(UploadFile);


export default connect(mapStateToProps)(ConnectedForm);
